<template>
  <div class="kt-form">
    <div class="kt-login__head">
      <h3 class="kt-login__title">Reset Password Form</h3>
      <div class="kt-login__desc">Reset Your Password Below:</div>
    </div>
    <div class="input-group">
      <input
        class="form-control"
        type="text"
        placeholder="Email"
        name="email"
        v-validate="'required|email'"
        v-model="email"
      />
    </div>
    <span class="kt-font-danger validate-error" v-show="errors.has('email')">
      {{ errors.first('email') }}
    </span>
    <div class="input-group">
      <input
        class="form-control"
        type="password"
        placeholder="Password"
        name="password"
        v-validate="'required|confirmed:password_confirmation'"
        v-model="password"
      />
    </div>
    <span class="kt-font-danger validate-error" v-show="errors.has('password')">
      {{ errors.first('password') }}
    </span>

    <div class="input-group">
      <input
        class="form-control"
        type="password"
        placeholder="Password Confirmation"
        name="password_confirmation"
        v-validate="'required'"
        v-model="password_confirmation"
        ref="password_confirmation"
      />
    </div>
    <span
      class="kt-font-danger validate-error"
      v-show="errors.has('password_confirmation')"
    >
      {{ errors.first('password_confirmation') }}
    </span>
    <div class="kt-login__actions">
      <button
        @click="resetPassword"
        class="btn btn-brand btn-pill kt-login__btn-primary"
        :class="
          loader
            ? 'kt-spinner kt-spinner--v2 kt-spinner--right kt-spinner--sm kt-spinner--warning'
            : ''
        "
      >
        Submit
      </button>
      <v-spacer />
      <v-spacer />
      <button
        @click="closeSignUp"
        id="kt_login_signup_cancel"
        class="btn btn-secondary btn-pill kt-login__btn-secondary"
      >
        Cancel
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResetPassword',
  props: {
    closeSignUp: {
      type: Function,
    },
  },
  data() {
    return {
      email: '',
      password: '',
      password_confirmation: '',
      loader: false,
    };
  },
  methods: {
    resetPassword() {
      this.loader = true;
      this.$http
        .post('/reset/password/', {
          token: this.$route.params.token,
          email: this.email,
          password: this.password,
          password_confirmation: this.password_confirmation,
        })
        .then((result) => {
          this.$notify('success', result.data.message);
          this.signIn();
        })
        .catch((errors) => {
          this.interactWithErrorBag(errors, this.errors);
          if (errors.response.data.message === 'Failed, Invalid Token.') {
            this.$notify('error', 'The link you access is expired.');
          }
        });
      this.loader = false;
    },
    signIn() {
      this.$store.commit('dealerOptions/setOptions', []);
      this.loader = true;
      this.setOptions();
      this.$auth
        .login({
          email: this.email,
          password: this.password,
        })
        .then(({ data }) => {
          this.loader = false;
          this.$http.defaults.headers.common.Authorization = `Bearer ${data.access_token}`;
        })
        .catch((err) => {
          this.loader = false;
        });
    },
    setOptions() {
      this.$store
        .dispatch('dealerOptions/getOptions', this.email)
        .then(({ data }) => {
          this.$store.commit('dealerOptions/setOptions', data);
        });
    },
  },
};
</script>

<style scoped></style>
